import React from 'react';
import { ProjectsListing } from '@components/projectsListing/projectsListing';
import { apiUrls } from '@constants/apiurls';
import projects from '@redux/modules/projects';
import styles from '@components/dashboard/dashboard.module.scss';
import { routesPath } from '@constants/routesPath';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { ClientHeader } from '@components/clientHeader/clientHeader';
import clients from '@redux/modules/clients';
import { Spinner } from 'components/loader/loader';

export const ProjectsContainer = () => {
  const navigate = useNavigate();
  const params = useParams();
  const {
    data: projectsData,
    isLoading: projectsLoading,
    error: projectsError,
    isSuccess: projectsSuccess,
  } = projects.list().useProjectlistQuery({ params: '', extendedPath: apiUrls.getProjects() });

  const {
    data: clientData,
    error: clientError,
    isFetching: clientLoading,
  } = clients.list().useClientsdetailQuery(
    { params: { id: params.clientId }, extendedPath: apiUrls.getClientDetail() },
    {
      skip: !params.clientId,
    },
  );
  const onEdit = () => {
    navigate(routesPath.editClient(params.clientId));
  };
  
  const onProjectSettings = () => {
    navigate(routesPath.addProjects(params.clientId));
  };
  
  return (
    <div className={styles.dashboardWrappper}>
      <ClientHeader 
        projects={projectsData?.data} 
        clientData={clientData?.data} 
        onEdit={onEdit}
        onProjectSettings={onProjectSettings}
      />
      <Outlet />
    </div>
  );
};
